import { useEffect, useState } from "react";
import { CheckCircle2, Trash2, Clock, Award } from "lucide-react";
import Btn from "../components/Btn";
import api, { API } from "../lib/api";
import { toast } from "sonner";

export default function AdminSuccessStories() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("pending");

  const load = () => {
    const q = filter === "all" ? "" : `?status=${filter}`;
    api.get(`/admin/success-stories${q}`).then(({ data }) => setRows(data.stories)).catch(() => {});
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  const approve = async (id) => {
    try { await api.post(`/admin/success-stories/${id}/approve`); toast.success("Testimoni disetujui & tampil di Beranda"); load(); }
    catch { toast.error("Gagal menyetujui"); }
  };
  const del = async (id) => {
    if (!window.confirm("Hapus testimoni ini?")) return;
    try { await api.delete(`/admin/success-stories/${id}`); toast.success("Testimoni dihapus"); load(); }
    catch { toast.error("Gagal menghapus"); }
  };

  return (
    <div className="space-y-4" data-testid="admin-success-stories">
      <div className="flex items-center gap-2">
        {[["pending", "Menunggu"], ["approved", "Disetujui"], ["all", "Semua"]].map(([id, label]) => (
          <button key={id} data-testid={`ss-filter-${id}`} onClick={() => setFilter(id)}
            className={`px-4 py-1.5 rounded-xl font-heading font-extrabold text-sm border-2 ${filter === id ? "bg-su-primary text-white border-su-primaryShadow" : "bg-su-surface text-su-muted border-su-border"}`}>
            {label}
          </button>
        ))}
      </div>

      {rows.length === 0 ? (
        <div className="card-chunky p-8 text-center text-su-muted font-medium">Tidak ada testimoni.</div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-4">
          {rows.map((s) => (
            <div key={s.id} className="card-chunky p-4 flex gap-3" data-testid={`ss-row-${s.id}`}>
              <img src={`${API}/success-stories/${s.id}/photo`} alt="" className="w-16 h-16 rounded-xl object-cover border-2 border-su-border shrink-0" onError={(e) => { e.currentTarget.style.visibility = "hidden"; }} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <p className="font-heading font-black truncate">{s.name}</p>
                  {s.status === "pending"
                    ? <span className="inline-flex items-center gap-1 text-[10px] font-heading font-black px-2 py-0.5 rounded-full text-su-energy bg-su-energy/15"><Clock className="w-3 h-3" />Menunggu</span>
                    : <span className="inline-flex items-center gap-1 text-[10px] font-heading font-black px-2 py-0.5 rounded-full text-su-success bg-su-success/15"><CheckCircle2 className="w-3 h-3" />Tampil</span>}
                </div>
                {s.position && <p className="text-xs font-heading font-bold text-su-success truncate">{s.position}</p>}
                <p className="text-sm text-su-muted line-clamp-3 mt-1">"{s.comment}"</p>
                <div className="flex gap-2 mt-2">
                  {s.status !== "approved" && <Btn size="sm" onClick={() => approve(s.id)} data-testid={`ss-approve-${s.id}`}><CheckCircle2 className="w-4 h-4" /> Setujui</Btn>}
                  <Btn size="sm" variant="ghost" onClick={() => del(s.id)} data-testid={`ss-delete-${s.id}`}><Trash2 className="w-4 h-4" /> Hapus</Btn>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
